import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';
import { LoadingSpinner } from '@/components/ui/loading-spinner';
import { logger } from '@/lib/logger';
import { Capacitor } from '@capacitor/core';

const AuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        // On mobile (Android/iOS), DeepLinkHandler in App.tsx handles authentication
        // This component is primarily for web-based auth callbacks
        if (Capacitor.isNativePlatform()) {
          logger.info('Auth callback on native platform - handled by DeepLinkHandler');
          // Redirect to home as fallback
          navigate('/');
          return;
        }

        // Web-based authentication handling
        const hash = window.location.hash;
        
        if (!hash) {
          logger.warn('No hash in auth callback URL (web)');
          navigate('/login');
          return;
        }

        // Parse hash parameters
        const params = new URLSearchParams(hash.replace('#', '?'));
        const accessToken = params.get('access_token');
        const refreshToken = params.get('refresh_token');
        const type = params.get('type');

        logger.info('Auth callback received (web)', { type, hasAccessToken: !!accessToken });

        if (accessToken && refreshToken) {
          // Set session with tokens
          const { error } = await supabase.auth.setSession({
            access_token: accessToken,
            refresh_token: refreshToken,
          });

          if (error) {
            logger.error('Failed to set session (web)', error);
            navigate('/login');
            return;
          }

          logger.info('Session set successfully (web)');
          
          // Redirect based on type
          if (type === 'recovery') {
            navigate('/reset-password');
          } else {
            navigate('/onboarding');
          }
        } else {
          logger.warn('Missing tokens in auth callback (web)');
          navigate('/login');
        }
      } catch (error) {
        logger.error('Auth callback error', error);
        navigate('/login');
      }
    };

    handleAuthCallback();
  }, [navigate]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-background">
      <LoadingSpinner size="lg" />
      <p className="mt-4 text-muted-foreground">Autenticando...</p>
    </div>
  );
};

export default AuthCallback;
